<template>
    <div class="scoreSeat">
        <div class="slider-range-bg">
            <div
                :style="'width:'+longRatio+';left:'+leftRatio"
                class="slider-range">
            </div>
            <div class="slider">
                <div class="block">
                    <el-slider
                            v-model="myPosition"
                            :max="maxPosition"
                            @input="changePosition"
                            @change="changedPosition"
                            range>
                    </el-slider>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "scoreSeat",
        props: {
            max: {
                type: Number
            },
            my: {
                type: Array
            }
        },
        data() {
            return {
                myPosition: [],
                maxPosition: null,
                // 中间线段长度占比
                longRatio: '',
                // 线段左侧长度占比
                leftRatio: '',
            }
        },
        watch: {
            max: function(val){
                this.maxPosition = val;
            },
            my: function (val) {
                this.myPosition = val;
            }
        },
        mounted() {

        },
        methods: {
            // 拖动slider
            changePosition() {
                this.$emit('changePosition',this.myPosition);

                let child = this.myPosition[0];
                let long = this.myPosition[1] - this.myPosition[0];
                let parent = Number(this.maxPosition);
                let leftRatio = (child / parent) *100 + '%';
                let longRatio = (long / parent) *100 +'%';
                this.longRatio = longRatio;
                this.leftRatio = leftRatio;
                // console.log('最左边位于整条线的比例'+leftRatio);
                // console.log('中间线段长度占整条线的比例'+longRatio);
            },
            changedPosition() {
                this.$emit('changedPosition',this.myPosition);
            }
        }
    }
</script>

<style scoped lang="scss">
    .slider-range-bg{
        width: 740px;
        height: 110px;
        margin: 10px 0 20px 40px;
        position: relative;
        background: #F7F9FA url("../../../../assets/img/scoreSeatBg.png") no-repeat center top;
        .slider-range{
            height: 112px;
            width: 20px;
            background-color: rgba(64, 158, 255,0.3);
            position: absolute;
            left: 0;
            top: 0;
        }
        .slider{
            width: 738px;
            height: 38px;
            position: absolute;
            bottom: -18px;
        }
    }

</style>